import React from "react";
import StatusBadge, {
  StatusBadgeColorVariant,
} from "@/shared/components/StatusBadge";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { ClaimStatus } from "@/features/my-order/features/order-history/features/claim/types";

interface Props {
  status: ClaimStatus;
}

function ClaimStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();
  const claimVariantMap: Record<ClaimStatus, StatusBadgeColorVariant> = {
    PENDING: "white",
    PROGRESSING: "blue",
    COMPLETED: "green",
    REJECTED: "red",
    CANCELED: "red",
  };

  return (
    <StatusBadge
      status={tTitle(`order_history:claim.status_${status.toLowerCase()}`)}
      colorVariant={claimVariantMap[status] ?? "white"}
      size={"medium"}
    />
  );
}

export default ClaimStatusBadge;
